<template>
    <el-card>
        <div slot="header" class="move d-flex justify-content-between">
            <h3>Team Settled Leaderboard</h3>
        </div>

        <div class="mt-4 text-center">
            <span class="card-value"><h2>{{ combinedTotalFormatted }}</h2></span>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'TeamSettledChart',
    components: {
    },
    props: [
        'teamLeaderboard',
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            teamSettled: [],
            labels: [],
            datasets: []
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.teamSettled = event.teamLeaderboards.teamLeaderboards

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.teamSettled = event.teamLeaderboards.teamLeaderboards

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    computed: {
        combinedTotal() {
            return (this.teamSettled && _.reduce(_.get(this.teamSettled, 'values.total_settlements', []), (sum, x) => sum + x) > 0) ? _.reduce(_.get(this.teamSettled, 'values.total_settlements', []), (sum, x) => sum + x) : 0
        },
        combinedTotalFormatted() {
            return this.combinedTotal
        },
        totalTeams() {
            return this.teamSettled.labelsSettled ? this.teamSettled.labelsSettled.length : 0;
        }
    },
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255,255,255, 0.9)'
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        },
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}

.lender-logo {
    height: 41px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    -webkit-transition: background-image 0.2s ease-in-out;
    transition: background-image 0.2s ease-in-out;
}

.lender-logo .lender-text {
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
